/**
 * MJ-Lab Ver.3 — Award-Level Interactions
 */
import { initCursor } from './modules/cursor.js';
import { initHeader } from './modules/header.js';
import { initDrawer } from './modules/drawer.js';
import { initMagneticButtons, initClipReveals, initStaggerGrids, initDividers, initLectureCards } from './modules/interactions.js';
import { initCreationsFilter } from './modules/creations-filter.js';
import { initGallery } from './modules/gallery.js';
import { initGsapAnimations } from './modules/gsap-animations.js';
import { initBottomNav } from './modules/bottom-nav.js';
import { initSimulator } from './modules/simulator.js';
import { initTagFilterForm } from './modules/tag-filter.js';
import './modules/scroll-to-list.js';
import './modules/scroll-to-service-anchor.js';

initCursor();
initHeader();
initDrawer();
initMagneticButtons();
initClipReveals();
initStaggerGrids();
initDividers();
initLectureCards();
initCreationsFilter();
initGallery();
initGsapAnimations();
initBottomNav();
initSimulator();
initTagFilterForm();
